//CHARTS
export const GET_CHART_DATA = "GET_CHART_DATA";
export const SHOW_CHART_LOADER = "SHOW_CHART_LOADER";
export const CHART_ERROR = "CHART_ERROR";
